import React from 'react'
import URL from '../../../../_Components/URL'
import Container from '../../../../../../_layouts/Container'
import LandingPage from '../../../../../../_assets/images/landing-page-crop.png'

import { Image, Card, Col, Row } from 'react-bootstrap';

export default function GetStarted({ startSetup }) {
  return <Container>
    <Row>
      <Col xs='12'>
        <Card>
          <Card.Body>
            <h4 className="font-weight-bold">Your Landing Page</h4>
            <Row>
              <Col style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
                <p>
                  With your personalized landing page, you can allow patients to complete selected forms and receive patient messages.
                </p>
                <p className="my-4">
                  The patient simply scans your QR code or visits your personalized domain, and they instantly have access to your landing page.
                </p>
                <p className='pt-5'>
                  <button onClick={startSetup} className="btn btn-block btn-success">Get Started</button>
                </p>
              </Col>
              <Col xs='8'>
                <Row className='mb-3 justify-content-center'>
                  <Col className='my-auto'>
                    <URL urlString={`https://yourname.${process.env.REACT_APP_DOMAIN}`} />
                  </Col>
                </Row>
                <Row>
                  <Col >
                    <Image className='border rounded p-2' src={LandingPage} fluid />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </Container>
}
